import React from 'react'
import { MessageCircle } from 'lucide-react'

const CTASection: React.FC = () => {
  return (
    <section className="py-20 text-white" style={{ backgroundColor: '#475569' }}>
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          Ready to illuminate your software future?
        </h2>
        <p className="text-xl mb-8" style={{ color: 'var(--text-muted)' }}>
          Let's discuss how Code Beacon can guide your next project to success
        </p>
        <a href="mailto:hello@code-beacon.io" className="cta-get-started">
          <MessageCircle className="w-5 h-5 inline mr-2" />
          Get Started Today
        </a>
      </div>
    </section>
  )
}

export default CTASection